let view = null;

export default {
	namespace: 'single-publication',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: PublicationItemView } = await import(
			/* webpackChunkName: "publication-item-view" */ '../../templates/PublicationItemView'
		);
		view = new PublicationItemView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
